import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleCheck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.233398 7.00104C0.233398 3.26391 3.26294 0.234375 7.00006 0.234375C10.7372 0.234375 13.7667 3.26391 13.7667 7.00104C13.7667 10.7382 10.7372 13.7677 7.00006 13.7677C3.26294 13.7677 0.233398 10.7382 0.233398 7.00104ZM9.70928 6.11566C10.0133 5.90803 10.0915 5.49322 9.88388 5.18916C9.67625 4.88509 9.26145 4.80692 8.95739 5.01455L8.88986 5.06067C7.79593 5.80766 6.85299 6.75058 6.1073 7.83933L5.13782 6.87089C4.87733 6.61068 4.45522 6.6109 4.19501 6.87139C3.9348 7.13188 3.93503 7.55399 4.19551 7.8142L5.75631 9.37333C5.90324 9.5201 6.11017 9.59002 6.31601 9.56244C6.52185 9.53485 6.70308 9.41292 6.80618 9.23264C7.50676 8.0076 8.47632 6.95759 9.64175 6.16177L9.70928 6.11566Z",
		fill: "#15803D"
	})
});
const ForwardRef = forwardRef(SvgCircleCheck);
export default ForwardRef;
